var React = require('react');

function DarkZendeskLogo (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#ffffff;}\n"),React.createElement("path",{"className":"st0","d":"M13.9,6v16.7H0L13.9,6z M13.9,0c0,3.8-3.1,6.9-6.9,6.9S0,3.8,0,0H13.9z M16.1,22.7c0-3.8,3.1-6.9,6.9-6.9\n\ts6.9,3.1,6.9,6.9H16.1z M16.1,16.7V0H30L16.1,16.7L16.1,16.7z","key":1})]);
}

DarkZendeskLogo.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 30 22.7","style":{"enableBackground":"new 0 0 30 22.7"},"xmlSpace":"preserve"};

module.exports = DarkZendeskLogo;

DarkZendeskLogo.default = DarkZendeskLogo;
